import glamorous from 'glamorous';
import { mediaQueries } from '../../constants/mediaqueries.const';
import swoosh from '../../images/NikeSwoosh.svg'

const nikeBlue = '#021A3B';
const nikeWhite = '#FFFFFF'

export const ButtonArray = glamorous.div(() => ({
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: '20px',
    overflowX: 'auto',
    gap: '16px',
}));
ButtonArray.displayName = 'ButtonArray';

export const MaximButton = glamorous.div(() => ({
    position: 'relative',
    width: '135px',
    height: '135px',
    background: nikeWhite,
    boxShadow: '0px 2px 4px rgba(134, 134, 134, 0.316133)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
    border: '2px solid transparent',
    flexShrink: 0,
    cursor: 'pointer',
    '&:hover': {
        border: `2px solid #CCC`,
    },
}));
MaximButton.displayName = 'MaximButton';

export const BottomText = glamorous.div(() => ({
    marginTop: '30px',
    position: 'absolute',
    bottom: '12px',
    fontFamily: 'Helvetica Neue',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '24px'
}));
BottomText.displayName = 'BottomText';

export const MiddleText = glamorous.div(() => ({
    fontFamily: 'Helvetica Neue',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    margin: '10px',
}));
MiddleText.displayName = 'MiddleText';


// WEBPACK FOOTER //
// ./src/components/MaximButtonArray/MaximButtonArray.style.js